import { setStyle } from 'redom';
import { SystemLayer } from './systemLayer';
import { SystemEvent } from './system';

/**
 * Complete SystemLayer with more assets needed for an Intale
 */

export class SystemUi extends SystemLayer {
    constructor(canvas: HTMLCanvasElement) {
        super(canvas);

        // Code to avoid mouse pointer showing when mesh is hovered but not visible
        this.scene.pointerMovePredicate = (m) => m.isPickable
            && m.isVisible
            && m.isReady()
            && m.isEnabled();

        // NOTE Code to test who is under mouse
        // window.addEventListener("click", () => {
        //    // We try to pick an object
        //    var pickResult = this.scene.pick(this.scene.pointerX, this.scene.pointerY);
        //    console.log(pickResult.pickedMesh)
        // });

        // NOTE Code to launch BabylonJS Spector
        // scene.debugLayer.show({
        //     popup:false,
        //     initialTab : 2,
        //     // parentElement:document.getElementById('#mydiv'),
        //     newColors: {
        //         backgroundColor: '#eee',
        //         backgroundColorLighter: '#fff',
        //         backgroundColorLighter2: '#fff',
        //         backgroundColorLighter3: '#fff',
        //         color: '#333',
        //         colorTop:'red',
        //         colorBottom:'blue'
        //     }
        // });

        this.on(SystemEvent.Resize, () => {
            this.checkCanvasRatio();
        });

        this.on(SystemEvent.Start, () => {
            this.checkCanvasRatio();
        });
    }

    private keepSquareCanvas = false

    public setKeepSquareCanvas(keepSquareCanvas: boolean): void {
        this.keepSquareCanvas = keepSquareCanvas;
        this.checkCanvasRatio();
    }

    private checkCanvasRatio() {
        if (this.keepSquareCanvas) {
            const parent = this.canvas.parentNode;
            const min = Math.min(parent.clientWidth, parent.clientHeight);
            setStyle(this.canvas, {
                width: min, height: min, top: '50%', left: '50%', transform: 'translate(-50%, -50%)'
            });
            this.engine.resize();
        } else {
            setStyle(this.canvas, {
                width: '100%', height: '100%', top: '0px', left: '0px', transform: 'none'
            });
        }
    }
}
